module.exports = __webpack_public_path__ + "img/loading.d431ac83.svg";